import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';

import { AuthService } from '../../../services/auth.service';
import { SessionService } from '../../../services/session.service';
import { CampaignContentService } from '../../../services/campaign-content.service';
import { NavigationService } from '../../../services/navigation.service';

export const UniversalIdGuard: CanActivateFn = (route, state): Observable<boolean> | boolean | UrlTree => {
  const campaignContentService = inject(CampaignContentService);
  const navigationService = inject(NavigationService);
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);

  campaignContentService.captureCampaignCode();
  const ses = sessionService.getData();

  sessionStorage.setItem('universalIdRedirectUrl', state.url);
  sessionStorage.setItem('universalIdReferrerUrl', window.document.referrer);

  if (!authService.isAuthenticated() && !sessionStorage.getItem('universalIdResultFound')) {

    let navigateTo =
      ses?.user?.identificationStatus !== 'ONE_RESULT'
        ? '/status/identification/identify'
        : '/status/identification/identified';

    if (route?.queryParams && route?.queryParams['embeddedWebApp'] === 'true') {
      navigateTo = navigateTo.split('?')[1] ? navigateTo + '&embeddedWebApp=true' : navigateTo + '?embeddedWebApp=true';
    }

    const newURL = campaignContentService.appendCampaignCodeToQueryString(navigateTo);

    navigationService.toUrl(newURL);
    return false;
  }

  sessionStorage.removeItem('universalIdRedirectUrl');
  sessionStorage.removeItem('universalIdReferrerUrl');

  return true;
};

// UniversalIdGuard 2024 (c) - Handcrafted by Kiley J. Park.
